import React from "react";
// import Toggle from "../common/toggle";
import Toggle from "../common/togglecustom";
const Monthtogle = ({
  list,
  handleOnClick,
  textProperty,
  valueProperty,
  valueCheck,
  disabled = false,
}) => {

   
  return (
    <div className="row course-list list m-1">
      {list &&
        list.map((item) => (
          <div key={item._id} className="col-xs-12 col-sm-6 col-lg-1 col-xl-1">
            <Toggle
              key={item[valueProperty]}
              id={item[valueProperty]}
              name={item[valueProperty]}
              checked={item[valueCheck]}
              disabled={item[disabled]}
              onChange={(e) =>
                handleOnClick(
                  e,
                  item[valueProperty],
                  item[textProperty],
                  item[disabled]
                )
              }
              text={item.name}
            />
          </div>
        ))}
    </div>
  );
};
Monthtogle.defaultProps = {
  textProperty: "name",
  valueProperty: "_id",
  valueCheck: "chkselected",
  disabled: "disabled",
};

export default Monthtogle;
